import { ITenant, ITenantBody } from 'src/types/tenant.type';
import http from 'src/utils/http';
import BaseService from './base.service';

export default class TenantService extends BaseService<ITenant, {}, ITenantBody> {
  constructor() {
    super('/api/tenant');
  }

  public async updateProfile(id: number, body: ITenantBody, logo?: File) {
    const formData = new FormData();
    formData.append('name', body.name || '');
    formData.append('site', body.site || '');
    formData.append('status', body.status?.toString() || '');

    if (logo) {
      formData.append('logo', logo);
    }

    const { data } = await http.put<boolean>(`${this.url}/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 1000 * 60 * 3,
    });
    // const { data } = await http.put<boolean>(this.url, body);
    return data;
  }
}
